import React from "react";

// Animated SVG progress ring
export function ProgressRing({ value = 0, max = 100, size = 140, stroke = 10, color = "#6AA6FF", label, sublabel, children }) {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const pct = Math.min(value / max, 1);
  const offset = circ * (1 - pct);
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="rgba(255,255,255,0.07)" strokeWidth={stroke} />
        <circle
          cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={color} strokeWidth={stroke}
          strokeLinecap="round" strokeDasharray={circ} strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 1s cubic-bezier(0.22,1,0.36,1)", filter: `drop-shadow(0 0 8px ${color}66)` }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        {children || (
          <>
            <span className="font-display text-2xl font-bold text-mist">{label}</span>
            {sublabel && <span className="mt-0.5 text-[11px] uppercase tracking-wider text-mist-muted">{sublabel}</span>}
          </>
        )}
      </div>
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, sub, accent = "#6AA6FF" }) {
  return (
    <div className="glass rounded-2xl p-4">
      <div className="flex items-center gap-2 text-mist-muted">
        {Icon && (
          <span className="flex h-8 w-8 items-center justify-center rounded-lg" style={{ background: `${accent}22`, color: accent }}>
            <Icon size={16} />
          </span>
        )}
        <span className="text-xs font-medium uppercase tracking-wider">{label}</span>
      </div>
      <div className="mt-3 font-display text-2xl font-bold text-mist">{value}</div>
      {sub && <div className="mt-0.5 text-xs text-mist-muted">{sub}</div>}
    </div>
  );
}

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="mb-8 flex items-end justify-between gap-4">
      <div>
        <h1 className="text-3xl font-semibold text-mist sm:text-4xl">{title}</h1>
        {subtitle && <p className="mt-2 text-sm text-mist-muted">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function Bar({ value, max, color = "#6AA6FF" }) {
  const pct = Math.min((value / max) * 100, 100);
  return (
    <div className="h-2 w-full overflow-hidden rounded-full bg-white/[0.06]">
      <div className="h-full rounded-full" style={{ width: `${pct}%`, background: color, transition: "width 0.8s cubic-bezier(0.22,1,0.36,1)" }} />
    </div>
  );
}

export function PageWrap({ children }) {
  return <div className="mx-auto max-w-5xl px-5 py-8 lg:px-10 lg:py-12">{children}</div>;
}
